<template>
	<div class="person-center">
		<div class="my-head">
			<van-image width="70" height="70" round fit="cover" lazy-load :src="userInfo.headimgUrl||defaultImg" />
			<label class="nickname">{{userInfo.trueName}}</label>
			<!--0未认证  2：房主认证  20：待审核  -->
			<van-button round color="#f0b631" size="small" class="rzbtn" v-if="identity=='2'">房屋认证</van-button>
		</div>
		<div class="mt10 minelist">
			<van-cell is-link to="/common/list/wdxx">
				<template #title>
					<img src="~@img/grzx/wdxx.png" alt="" class="icon">
					<div>我的消息</div>
				</template>
			</van-cell>
			<van-cell is-link to="/userinfo">
				<template #title>
					<img src="~@img/grzx/grxx.png" alt="" class="icon">
					<div>个人信息</div>
				</template>
			</van-cell>
			<van-cell is-link  to="/fzrz">
				<template #title>
					<img src="~@img/grzx/yzrz.png" alt="" class="icon">
					<div>房屋认证</div>
				</template>
			</van-cell>
			<van-cell is-link to="/user/invoiceHistory">
				<template #title>
					<svg class="icon" viewBox="0 0 48 48" width="24" height="24">
						<defs>
							<linearGradient id="kpjlGrad" x1="0%" y1="0%" x2="100%" y2="100%">
								<stop offset="0%" style="stop-color:#FF6B35;stop-opacity:1" />
								<stop offset="100%" style="stop-color:#FF8C42;stop-opacity:1" />
							</linearGradient>
						</defs>
						<path d="M12 6 L30 6 L36 12 L36 42 L12 42 Z" fill="url(#kpjlGrad)" />
						<path d="M30 6 L30 12 L36 12 Z" fill="#E55A2B" />
						<line x1="17" y1="18" x2="31" y2="18" stroke="white" stroke-width="2" stroke-linecap="round"/>
						<line x1="17" y1="24" x2="31" y2="24" stroke="white" stroke-width="2" stroke-linecap="round"/>
						<line x1="17" y1="30" x2="26" y2="30" stroke="white" stroke-width="2" stroke-linecap="round"/>
					</svg>
					<div>开票记录</div>
				</template>
			</van-cell>
			<!-- 按客户要求暂时隐藏意见反馈入口 -->
			<!-- <van-cell is-link to="/yjfk">
				<template #title>
					<img src="~@img/grzx/yjfk.png" alt="" class="icon">
					<div>投诉建议</div>
				</template>
			</van-cell> -->
			<!-- <van-cell is-link to="/yjfk">
				<template #title>
					<img src="~@img/grzx/yjfk.png" alt="" class="icon">
					<div>意见反馈</div>
				</template>
			</van-cell> -->
			<van-cell is-link  to="/user/newgdyy">
				<template #title>
					<img src="~@img/grzx/gdyy.png" alt="" class="icon">
					<div>更多应用</div>
				</template>
			</van-cell>
		</div>
		<div class="footer-tip">
			<p>意见反馈请拨打12345或0527-84387312进行反映</p>
			<p>主办单位：宿迁市住房和城乡建设局</p>
		</div>

	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Image as VanImage
	} from 'vant';
	import {
		Lazyload,
		Form,
		Popup
	} from 'vant';
	Vue.use(VanImage);
	Vue.use(Lazyload);
	Vue.use(Popup);
	Vue.use(Form);
	import {
		mapState,
		mapMutations
	} from 'vuex';
	export default {
		data() {
			return {
				defaultImg:require('../../assets/grzx/head.png'),
				list:[
					{
						icon: require("../../assets/icon/xqgg.png"),
						name: "小区公告",
						to: '/common/list/xqgs'
					},
					{
						icon: require("../../assets/icon/yzjc.png"),
						name: "业主决策",
						to: '/yzjc'
					},
					{
						icon: require("../../assets/icon/wyfw.png"),
						name: "物业服务",
						to: '/wyfw'
					},
					{
						icon: require("../../assets/icon/shjf.png"),
						name: "业主缴费",
						to: '/wyfw/shjf'
					},
					{
						icon: require("../../assets/icon/tsbx.png"),
						name: "报事报修",
						to: '/tsbx?type=bx'
					},{
						icon: require("../../assets/icon/wxzj.png"),
						name: "维修资金",
						to: '/zhzfz'
					},
				]
			};
		},
		computed: {
			...mapState(['userInfo','identity']),
		},
		/* watch: {
		  $route(to, from) {
		    console.log("无论路由切换到哪都会触发")
		  },
		}, */
		mounted() {
			console.log(this.identity)
		},
		beforeRouteEnter(to, from, next) {
			next();
		},
		activated() {
		},
		methods: {
			...mapMutations(['changeIdentity','changeUserinfo']),
			changeview(path) {
				this.$router.push(path);
			},
		}
	};
</script>

<style lang="less" scoped>
	.person-center {
		min-height: 100vh;
		display: flex;
		flex-direction: column;

		// padding: 15px;
		.my-head {
			height: 180px;
			background: url("~@img/grzx/topbg.png") no-repeat center;
			background-size: cover;
			.flexcenter();
			flex-direction: column;
		}
	}

	.mt10 {
		margin-top: 10px;
	}

	.flexcenter {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.fcz{
		padding: 10px 20px;
	}	
	.nickname {
		font-size: 18px;
		color: #fff;
		padding: 5px 0 10px;
	}

	.rzbtn {
		border-color: #fff !important;
		height: 26px;
	}

	.minelist {
		.icon {
			float: left;
			height: 24px;
			width: 24px;
			margin-right: 20px;
		}
	}

	.title {
		color: #ffad0e;
		font-size: 18px;
		text-align: center;
		margin: 5px 0 10px;
		font-weight: bold;
		margin-top: 30px;
	}

	.tip {
		color: #ffa5a5;
		font-size: 12px;
		padding: 0px 5px 0 25px;
	}

	.footer-tip {
		margin-top: auto;
		padding: 15px 15px 75px;
		text-align: center;
		color: #999;
		font-size: 14px;
		line-height: 22px;

		p {
			margin: 0;
		}
	}
</style>
